var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6654 1.89062V5.33274C11.6654 5.79945 11.6654 6.03281 11.7562 6.21107C11.8361 6.36787 11.9636 6.49535 12.1204 6.57525C12.2986 6.66607 12.532 6.66607 12.9987 6.66607H16.4408M13.332 10.8327H6.66536M13.332 14.166H6.66536M8.33203 7.49935H6.66536M11.6654 1.66602H7.33203C5.9319 1.66602 5.23183 1.66602 4.69705 1.9385C4.22665 2.17818 3.8442 2.56063 3.60451 3.03104C3.33203 3.56582 3.33203 4.26588 3.33203 5.66602V14.3327C3.33203 15.7328 3.33203 16.4329 3.60451 16.9677C3.8442 17.4381 4.22665 17.8205 4.69705 18.0602C5.23183 18.3327 5.9319 18.3327 7.33203 18.3327H12.6654C14.0655 18.3327 14.7656 18.3327 15.3003 18.0602C15.7707 17.8205 16.1532 17.4381 16.3929 16.9677C16.6654 16.4329 16.6654 15.7328 16.6654 14.3327V6.66602L11.6654 1.66602Z",
    stroke: "#38cb89",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfPage);
export default __webpack_public_path__ + "static/media/pdf-page.a0f6d4cc1921e5ceb5a17967360602e7.svg";
export { ForwardRef as ReactComponent };